import { nativeBaseTheme } from '@rbilabs/universal-components/themes/bk/native-base-theme';
import { LinearGradient } from 'expo-linear-gradient';
import { NativeBaseProvider } from 'native-base';

export const UclProvider = ({ children }: React.PropsWithChildren) => (
  <NativeBaseProvider
    theme={nativeBaseTheme as any}
    config={{
      dependencies: {
        'linear-gradient': LinearGradient,
      },
      suppressColorAccessibilityWarning: true,
    }}
  >
    {children}
  </NativeBaseProvider>
);
